import { ChangeDetectorRef, Component, OnInit, ViewChild, EventEmitter, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';

import { HisAuthService, HisUiService, HisNotificationService, HisSearchService, HisJobService, HisJobStatus } from 'hisng';

import { PersonService } from 'app/cs/psv/common/service/person.service';
import { PersonIdAssignmentSearchFormComponent } from './person-id-assignment-search-form.component';

@Component( {
    selector: 'psv-person-id-assignment-form',
    templateUrl: './person-id-assignment-form.component.html',
    standalone: false
} )
export class PersonIdAssignmentFormComponent implements OnInit {
    private hisUiService = inject(HisUiService);
    private hisAuthService = inject(HisAuthService);
    jobService = inject(HisJobService);
    personService = inject(PersonService);
    changeDetectorRef = inject(ChangeDetectorRef);
    notificationService = inject(HisNotificationService);
    hisSearchService = inject(HisSearchService);
    route = inject(ActivatedRoute);

    @ViewChild( PersonIdAssignmentSearchFormComponent, { static: false } ) searchFormComponent: PersonIdAssignmentSearchFormComponent;
    readonly SEARCH_CONFIG_PUBLICATION_ORCID_USER = 'cs/psv/searchOrcidIdsAndInternalUsers.xml';
    displaySearchForm = true;
    search: any = { configFile: this.SEARCH_CONFIG_PUBLICATION_ORCID_USER, groups: [] };
    lastStartedJob = new EventEmitter<HisJobStatus>();

    ngOnInit() {
        this.hisSearchService.loadSearchResult(this.search).pipe(filter(searchResult => searchResult.data.length > 0)).subscribe(() => {
            this.displayResults();
        });
        this.route.queryParams.pipe(filter(params => params['fromPortalMessage'] === 'true')).subscribe(() => {
            this.displayResults();
        } );
    }

    submitSearch( keyword: string ) {
	    this.notificationService.clear();
        this.personService.serchForOrcidIds( keyword ).subscribe(status => {
            console.log( 'The search job has been started successfully.');
            let msg = this.hisUiService.translate( 'fs.res.publication.import.orcid.user.search.started' );
            let header = this.hisUiService.translate( 'messagebox.singleSuccessTitle' );
            this.notificationService.info( msg, header );
            this.monitorStatus(status, 0);
        });
    }

    displaySearch(resetInputFields: boolean) {
        this.displaySearchForm = true;
        if (resetInputFields) {
            this.searchFormComponent.resetInputs();
        }
    }

    displayResults() {
        this.displaySearchForm = false;
        this.changeDetectorRef.detectChanges();
    }

    doImport( selectionOfFormResults?: any ) {
        let jobRequest = {
            jobKey: 'cs.psv.person.import.orcidIds.job',
            jobStarterKey: 'cs.psv.search-orcid-ids-import',
            executionType: 'JobManagement',
            searchRequest: { offset: 0, limit: -1, search: selectionOfFormResults.search },
            selectedRowData: selectionOfFormResults.selectedOptions,
            jobParams: {}
        };

        this.notificationService.clear();
        this.personService.inportOrcidIds( jobRequest ).subscribe(
            () => {
                console.log( 'The import job has been started successfully.');
                let msg = this.hisUiService.translate( 'cs.psv.person.idAssignment.orcid.started' );
                let header = this.hisUiService.translate( 'messagebox.singleSuccessTitle' );
                this.notificationService.success( msg, header );
            }, error => console.log( error )
        );
    }

    monitorStatus( status: HisJobStatus, iterationCount: number ) {
        if (!status?.finishedAt ) {
            setTimeout(
                () => {
                    this.jobService.getJobStatus( status?.handle ).subscribe(
                        ( currentStatus: HisJobStatus ) => {
                            if(currentStatus.finishedAt) {
                                this.lastStartedJob.emit(null);
                                this.displayResults();
                            } else {
                                this.lastStartedJob.emit(currentStatus);
                                this.monitorStatus( currentStatus, iterationCount + 1 );
                            }
                        }, error => {
                            console.log( error );
                        }
                    );
                },
                this.getDelayForIteration( iterationCount ) );
        }
    }

    getDelayForIteration( iterationCount: number ): number {
        return iterationCount < 5 ? iterationCount * 200 : iterationCount < 10 ? iterationCount * 400 : 5000;
    }
}
